// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"StoreBrandRefresh_pageWrapper__2tkOj"};